import apiClient from "@repo/ui/lib/apiClient";
import type { ApiResponse } from "@repo/ui/types";

export interface RemoveSssrsFromBookingInStateBody {
  ssrKeys: string[];
}

export type AddBaggageToBookingInStateResponse = ApiResponse<string | null>;

export async function removeSssrsFromBookingInState(
  payload: RemoveSssrsFromBookingInStateBody,
  tabSessionId: string | null,
): Promise<unknown> {
  const url = "/v1/ssr/booking";
  const response = await apiClient<unknown>(url, {
    method: "DELETE",
    headers: {
      accept: "application/json",
    },
    body: payload,
    withAuth: true,
    tabSessionId,
  });

  if (!response) {
    throw new Error(`Failed to remove extras to booking in-state: ${response}`);
  }

  return response;
}
